import { AppId, FCX, usePlatformContext } from "@datassential/platform-ui-lib";
import useCategoryProfileReports from "@apiHooks/useCategoryProfileReports";
import { iReportProPublication } from "@models/ReportProPublication";
import { ID } from "@models";
import CategoryProfileSectionTitle from "@pages/CategoryProfile/components/CategoryProfileSectionTitle/CategoryProfileSectionTitle";
import CategoryProfileCard from "@pages/CategoryProfile/components/CategoryProfileCard/CategoryProfileCard";
import CategoryProfileSubtitle from "@pages/CategoryProfile/components/CategoryProfileSubtitle/CategoryProfileSubtitle";
import PublicationCard, { PublicationCardTooltip } from "@components/PublicationCard/PublicationCard";
import AccessLink from "@components/AccessLink/AccessLink";
import { sanitizeUrl } from "@helpers";
import { CategoryProfileSectionComponentProps } from "@pages/CategoryProfile/CategoryProfile.constants";
import "./Reports.styles.scss";

const PUBLICATION_TEST_ID_BASE = "CategoryProfilePublication";

export const useReportsSectionData = (categoryId: ID) => {
    const { data, isLoading } = useCategoryProfileReports(categoryId);
    return { hasData: data.length > 0, isLoading, data };
};

const CategoryProfileReports: FCX<CategoryProfileSectionComponentProps> = ({ title, data }) => {
    const publications = data as iReportProPublication[];

    const { userInfo: { products, reportProDetailsUrl } } = usePlatformContext();
    const productRP = products[AppId.ReportPro];
    const detailsPath = process.env.REACT_APP_RP_ITEM_LINK ?? reportProDetailsUrl;

    return (
        <div className="CategoryProfile__section-content CategoryProfileReports" data-testid="blockCategoryProfileReports">
            <CategoryProfileSectionTitle title={title} />

            <CategoryProfileCard>
                <CategoryProfileSubtitle className="CategoryProfileReports__subtitle">
                    Found in
                </CategoryProfileSubtitle>

                <div className="CategoryProfileReports__cards">
                    {publications.map((publication, index) => {
                        const tooltipId = `category-profile-publication-${publication.id}`;
                        return (
                            <div className="CategoryProfileReports__card-cell" key={publication.id}>
                                <PublicationCard
                                    className="CategoryProfileReports__card"
                                    data={publication}
                                    index={index}
                                    link={`${productRP?.url ?? ""}${detailsPath}${publication.id}`}
                                    tooltipId={tooltipId}
                                    testIdBase={PUBLICATION_TEST_ID_BASE}
                                />
                                <PublicationCardTooltip
                                    className="CategoryProfileReports__card-tooltip"
                                    data={publication}
                                    index={index}
                                    tooltipId={tooltipId}
                                    testIdBase={PUBLICATION_TEST_ID_BASE}
                                />
                            </div>
                        );
                    })}
                </div>
            </CategoryProfileCard>

            <AccessLink
                url={productRP?.url ? sanitizeUrl(productRP.url) : null}
                text="More Report Pro"
                onContactUsClick={() => {}}
                testId="linkCategoryProfileMoreReportPro"
            />
        </div>
    );
};

export default CategoryProfileReports;
